import { captureException } from "../integrations/analytics/client";

type ErrorToastFn = (options: {
  title: string;
  description: string;
  variant: "destructive";
}) => void;

export const GENERIC_EXTERNAL_ERROR_MESSAGE =
  "We couldn't complete that request. Please try again.";

type GenericErrorSnackbarOptions = {
  title?: string;
  message?: string;
  logPrefix?: string;
};

export const showGenericErrorSnackbar = (
  toast: ErrorToastFn,
  options: GenericErrorSnackbarOptions = {}
) => {
  toast({
    title: options.title ?? "Something went wrong",
    description: options.message ?? GENERIC_EXTERNAL_ERROR_MESSAGE,
    variant: "destructive",
  });
};

export const handleExternalError = (
  toast: ErrorToastFn,
  error: unknown,
  options: GenericErrorSnackbarOptions = {}
) => {
  console.error(options.logPrefix ?? "External operation failed", error);
  captureException(error, {
    source: "handleExternalError",
    title: options.title,
    logPrefix: options.logPrefix,
  });
  showGenericErrorSnackbar(toast, options);
};
